
import React, { useEffect, useState } from "react";

import PathContext from "./context/path";
import StatesContext from "./context/states";
import Intro from './pages/Intro';
import Main from './pages/Main';
import Header from './components/Header';
import Footer from './components/Footer';
import Warning from './components/Warning';

const App = () => {


  const [isMobile, setMobile] = useState(false);
  const [router, setRouter] = useState('intro');
  const [videoSound, setVideoSound] = useState(true);
  const [videoSub, setVideoSub] = useState(false);
  const [videoFull, setVideoFull] = useState(false);
  const [theme, setTheme] = useState('white');
  const [hideMain, setHideMain] = useState(false);

  const updateTheme = (str) => setTheme(str);
  const updateRouter = (str) => {
    setHideMain(true);
    setTimeout(() => {
      setRouter(str);
    }, 500);
    setTimeout(() => {
      setHideMain(false);
    }, 1000);
  }

  const updateVideoSound = (bool) => setVideoSound(bool);
  const updateVideoSub = (bool) => setVideoSub(bool);
  const updateVideoFull = (bool) => setVideoFull(bool);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fullscreenchanged = (e) => {
      if (document.fullscreenElement === null) {
        setVideoFull(false);
      }
    }
    document.addEventListener("fullscreenchange", fullscreenchanged);
  }, []);

  useEffect(() => {
    const fullscreen = () => {
      if (document.fullscreenElement) return;
      document.body.style.background = '#000000';
      setTimeout(() => {
        var element = window.document.documentElement;
        if (element.webkitEnterFullscreen) { // Safari iOS
          element.webkitEnterFullscreen();
        } else if (element.webkitRequestFullscreen) { // Safari
          element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) { // IE/Edge
          element.msRequestFullscreen();
        } else if (element.mozRequestFullScreen) { // Firefox
          element.mozRequestFullScreen();
        } else if (element.requestFullscreen) {
          element.requestFullscreen();
        }  
      }, 100)
    }
    const exitFullscreen = () => {
      if (!document.fullscreenElement) return;
      document.body.style.background = '';
      setTimeout(() => {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) { // Safari
          document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) { // IE/Edge
          document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) { // Firefox
          document.mozCancelFullScreen();
        }
      }, 100);
    }
    if (videoFull) {
      fullscreen();
    } else {
      exitFullscreen();
    }
    const handleMobile = () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
      if (window.outerWidth < 1025 && !isMobile) {
        setMobile(true);
      }
      if (window.outerWidth > 1024 && isMobile) {
        setMobile(false);
        document.documentElement.style.setProperty('--vh', ``);

      }
    }
    handleMobile();
    window.addEventListener('resize', handleMobile);
    return () => {
      document.documentElement.style.setProperty('--vh', ``);
      window.removeEventListener('resize', handleMobile);
    }
  }, [isMobile, videoFull]);

  useEffect(() => {
    switch (router) {
      case 'intro':
        setTheme('start');
        break;
      case 'main':
        setTheme('white');
        break;
      case 'final':
        setTheme('white');
        break;
      default:
        setTheme(undefined)
        break;
    }
  }, [router]);

  // const basename = '.';
  const basename = window.MEDIA_URL;
  let content = null;
  let hideBurger = true;
  switch (router) {
    case 'main':
      hideBurger = false;
      content = <Main />
      break;

    default:
      hideBurger = true;
      content = <Intro />
      break;
  }
  return (
    <StatesContext.Provider value={{ isMobile: isMobile, updateRouter: updateRouter, hideMain: hideMain, updateVideoSound: updateVideoSound, updateVideoSub: updateVideoSub, updateVideoFull: updateVideoFull, videoSound: videoSound, videoSub: videoSub, videoFull, updateTheme: updateTheme, theme: theme }}>
      <PathContext.Provider value={basename}>
        <div className={theme === "invert" ? "wrap wrap_invert" : "wrap"}>
          <div className="wrap__inner">
            {isMobile ?
              <Warning />
              :
              null
            }
            <Header theme={theme} hideBurger={hideBurger} />
            {content}
            <Footer theme={theme} />
          </div>
        </div>
      </PathContext.Provider>
    </StatesContext.Provider>
  );

}


export default App;
